import React from "react";
import { Button, Grid } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Link from "~/components/element/Link";

/**
 * Component that should display when there are no existing jobs.
 */
const NoJobs = observer(({ onClick }) => (
  <Grid columns="one">
    <Grid.Row>
      <Grid.Column textAlign="center">
        <h2>You do not have any HDR job</h2>
        <Link as={Button} to="/create" onClick={onClick} primary>
          Create a New Job
        </Link>
      </Grid.Column>
    </Grid.Row>
  </Grid>
));

NoJobs.propTypes = {
  // disabled by default when browsing /panel/photo-editing/jobs url
  createPhotoEditingJobEnabled: PropTypes.bool,
  // optional. Set when outside react router context
  onClick: PropTypes.func,
};

export default NoJobs;
